// extracted by mini-css-extract-plugin
module.exports = {"root":"Footer_root__n6RYi","buttons":"Footer_buttons__3o8Bp"};